export enum UserToMembershipStatusEnum {
	Canceled = 'canceled',
	Active = 'active',
	Finished = 'finished',
}
